const fallback = () => {
  console.error('Incorrect HelpCenter data provider.');
  return Promise.reject();
};
const dp = {
  getSoftwareInfo: fallback
};
export const getHelpCenterDataProvider = () => {
  // ensure to return same instance as this function could be called in
  // hooks frequently.
  return dp;
};
//# sourceMappingURL=helpCenterDataProvider.js.map